<template>
    <custom-modal title="Poll Results" v-model="show" :loading="loading" @close="close()" :width="'900px'">
        <div>
            <v-card v-for="question in poll.questions" :key="question.id" class="mb-4">
                <v-card-title class="grey lighten-4 pa-0 px-2 py-1">
                    {{ question.text }}
                </v-card-title>
                <v-card-text class="px-2 py-2" v-if="question.sorted_options && question.sorted_options.length > 0">
                    <v-row dense>
                        <v-col cols="12" lg="6">
                            <v-simple-table dense>
                                <template v-slot:default>
                                    <thead>
                                        <tr class="text-uppercase">
                                            <th>label</th>
                                            <th>votes</th>
                                            <th>percent</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="option in question.sorted_options" :key="option.id">
                                            <td>
                                                <v-avatar
                                                    v-if="option.more_data && option.more_data.avatar"
                                                    size="30"
                                                    class="mr-2"
                                                >
                                                    <img :src="option.more_data.avatar" alt="avatar" />
                                                </v-avatar>
                                                <span>{{ option.label }}</span>
                                            </td>
                                            <td>{{ option.vote_count }}</td>
                                            <td>{{ option.vote_percent }}%</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <donut-chart
                                :data="question.chart_data"
                                :valueField="'count'"
                                :categoryField="'label'"
                                :height="'300'"
                            />
                            <!-- {{question.chart_data}} -->
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </div>
    </custom-modal>
</template>

<script>
import axios from '../../plugins/axios'
import CustomModal from '../util/CustomModal.vue'
import donutChart from '../charts/am5DonutChart.vue'

export default {
    components: {
        CustomModal,
        donutChart
    },
    data: () => ({
        show: false,
        loading: false,
        poll: {},
    }),
    methods: {
        open(poll_id) {
            this.loading = true
            axios.get(`/api/polls/${poll_id}/results`).then((resp) => {
                this.poll = resp.data
            }).finally(() => this.loading = false)

            this.show = true
        },
        close() {
            this.$emit('reload')
            this.resetData()
        },
        resetData() {
            Object.assign(this.$data, this.$options.data())
        },
    },
}
</script>

<style>

</style>